//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  props: {
    selectableUsers: {
      type: Array,
      default: () => [],
    },
    selectedUsers: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedUsersList: [],
    selectableUsersList: [],
  }),
  computed: {
    selectedUsersIds() {
      return this.selectedUsers.map((user) => user.id)
    },
  },
  watch: {
    selectedUsers: {
      handler() {
        this.syncSelectedUsers()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onUserSelection(selectedUsers) {
      this.$emit('selected-users', this.selectedUsersList)
    },
    syncSelectedUsers() {
      this.selectedUsersList = this.selectedUsers.map((user) => ({
        ...user,
        selected: this.selectedUsers.some(
          (selectedUser) => selectedUser.id === user.id
        ),
      }))
    },
  },
}
